<div class="rea-shell">
  <section class="hero-card">
    <div>
      <div class="eyebrow">Auto fetch</div>
      <h1>NRPC REA Report</h1>
      <p>Select the NRPC Regional Energy Account year and month, auto-fetch the available REA file, and save parsed rows directly into the portal.</p>
    </div>
    <div class="hero-icon">
      <lucide-icon [img]="SatelliteDishIcon" [size]="28"></lucide-icon>
    </div>
  </section>

  <section class="status-card">
    <div>
      <small>Source</small>
      <strong>https://www.nrpc.gov.in/comm/rea.html</strong>
    </div>
    <div>
      <small>Latest detected period</small>
      <strong>{{ latestSourceMonth() }}</strong>
    </div>
    <div class="status-actions">
      <label class="filter-field">
        <span>Month</span>
        <select [ngModel]="selectedMonth()" (ngModelChange)="updateMonth($event)">
          <option [ngValue]="null">All months</option>
          @for (month of monthOptions(); track month) {
            <option [ngValue]="month">{{ monthLabel(month) }}</option>
          }
        </select>
      </label>
      <label class="filter-field">
        <span>Year</span>
        <select [ngModel]="selectedYear()" (ngModelChange)="updateYear($event)">
          <option [ngValue]="null">All years</option>
          @for (year of yearOptions(); track year) {
            <option [ngValue]="year">{{ year }}</option>
          }
        </select>
      </label>
      <button type="button" class="primary-btn secondary-btn" [disabled]="sourceLoading() || autoFetching()" (click)="refreshSourceReports()">
        <lucide-icon [img]="RefreshCcwIcon" [size]="16"></lucide-icon>
        <span>{{ sourceLoading() ? 'Refreshing...' : 'Refresh Source List' }}</span>
      </button>
      <button type="button" class="primary-btn" [disabled]="sourceLoading() || autoFetching()" (click)="autoFetchReports()">
        <lucide-icon [img]="DownloadIcon" [size]="16"></lucide-icon>
        <span>{{ autoFetching() ? 'Auto Fetching...' : 'Auto Fetch New Reports' }}</span>
      </button>
    </div>
  </section>

  <div class="content-grid">
    <section class="list-card">
      <div class="section-head">
        <h2>Available On NRPC</h2>
        <span>{{ filteredSourceReports().length }} reports</span>
      </div>

      @if (sourceLoading()) {
        <div class="empty-state">Loading NRPC month-wise REA reports...</div>
      } @else if (filteredSourceReports().length === 0) {
        <div class="empty-state">No REA report links were detected on the NRPC source page.</div>
      } @else {
        <div class="table-wrap">
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Period</th>
                  <th>Type</th>
                  <th>Title</th>
                  <th>File</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (report of filteredSourceReports(); track report.report_key) {
                  <tr>
                    <td>{{ formatPeriod(report.report_month, report.report_year) }}</td>
                    <td>{{ report.report_type }}</td>
                    <td>{{ report.title }}</td>
                    <td>{{ report.file_name }}</td>
                    <td class="action-cell">
                      <button type="button" class="icon-btn text-btn" [disabled]="isSourceActionDisabled(report)" (click)="triggerSourceAction(report)">
                        <lucide-icon [img]="DownloadIcon" [size]="15"></lucide-icon>
                        <span>{{ sourceActionLabel(report) }}</span>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </section>

    <section class="detail-card">
      <div class="section-head">
        <h2>Saved In Portal</h2>
        <span>{{ savedReports().length }} files • Use refresh icon to refetch any saved report</span>
      </div>

      @if (saveLoading()) {
        <div class="empty-state">Loading saved reports...</div>
      } @else if (savedReports().length === 0) {
        <div class="empty-state">No REA reports have been saved yet.</div>
      } @else {
        <div class="saved-list">
          @for (report of savedReports(); track report.id) {
            <div class="saved-item">
              <div class="saved-copy">
                <strong>{{ formatPeriod(report.report_month, report.report_year) }} • {{ report.report_type }}</strong>
                <span>{{ report.title }}</span>
                <small>{{ report.original_name }} • {{ report.last_refetched_at || report.created_at }}</small>
              </div>
              <div class="saved-actions">
                <button type="button" class="icon-btn" title="Download saved file" (click)="downloadReport(report)">
                  <lucide-icon [img]="DownloadIcon" [size]="15"></lucide-icon>
                </button>
                <button type="button" class="icon-btn" title="Re-download from source" [disabled]="isRefetching(report.id)" (click)="refetchReport(report)">
                  <lucide-icon [img]="RefreshCcwIcon" [size]="15"></lucide-icon>
                </button>
              </div>
            </div>
          }
        </div>
      }
    </section>
  </div>
</div>
